"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SpeedIcon = _interopRequireDefault(require("./SpeedIcon"));
require("./styles.css");
var _slow = require("../../assets/slider/slow.svg");
var _fast = require("../../assets/slider/fast.svg");
var _Slider = _interopRequireDefault(require("@mui/material/Slider"));
var _colors = require("../../styles/colors");
var _speedContext = _interopRequireDefault(require("../../store/speed-context"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SpeedSlider = _ref => {
  let {
    isDeactivated
  } = _ref;
  const speedCtx = (0, _react.useContext)(_speedContext.default);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "speed-slider-container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SpeedIcon.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_slow.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "slider",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Slider.default, {
        disabled: isDeactivated,
        min: 0,
        max: 0.7,
        step: 0.01,
        "aria-label": "Volume",
        value: speedCtx.speed,
        onChange: (e, newValue) => speedCtx.setSpeed(newValue),
        sx: {
          color: _colors.MAIN_BLUE,
          padding: "0 !important;",
          "& .MuiSlider-thumb": {
            color: _colors.PALE_BLUE,
            border: "2px solid ".concat(_colors.MAIN_BLUE)
          }
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SpeedIcon.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fast.ReactComponent, {})
    })]
  });
};
var _default = exports.default = SpeedSlider;